import { useState } from "react";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";

function FormLookup(props: any) {
  if (props.hidden) return <></>;

  const [value, setValue] = useState(props.value);
  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value as string);
    props.onChange(event.target.value as string);
  };

  return (
    <div className={props.className ? props.className : "EditForm"}>
      {props.title ? <label className="EditLabel">{props.title}</label> : null}
      <div className="EditInputHolder">
        <Select
          value={value}
          className={props.className ? props.className : "EditForm"}
          onChange={handleChange}
          readOnly={props.readOnly ? props.readOnly : false}
          sx={{
            // Target the Mui-readOnly class within the Select component
            "&.Mui-readOnly": {
              backgroundColor: "#f0f0f0", // Change background color
              cursor: "default", // Change cursor to indicate no interaction
              pointerEvents: "none", // Prevent clicking to open the menu
            },
            // You might also want to hide the dropdown icon
            "&.Mui-readOnly .MuiSelect-icon": {
              display: "none",
            },
          }}
        >
          {Object.entries(props.enum as Object).map((t) => {
            return (
              <MenuItem key={t[0]} value={t[0]}>
                {t[1]}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    </div>
  );
}

export default FormLookup;
